import { Building2Icon, PlusIcon } from "lucide-react";
import { cn } from "@/utils/class-name";

interface ComposedLucideIconProps {
    className?: string;
    "aria-hidden"?: boolean;
}

export type ComposedLucideIconComponent = React.FC<ComposedLucideIconProps>;

/**
 * These are components that are 2 or more Lucide icons combined to create a single icon
 *
 * Make sure to pass through the className prop that is provided by icon component
 */

export function AddOrganizationIcon({ className, "aria-hidden": ariaHidden }: ComposedLucideIconProps) {
    return (
        <div className={cn("relative flex items-center justify-center", className)}>
            <Building2Icon className={"size-[90%] relative right-[5%]"} aria-hidden={ariaHidden} />
            <PlusIcon className={"absolute -right-[15%] -top-[10%] size-[45%] stroke-3"} aria-hidden={ariaHidden} />
        </div>
    );
}
